export default {
  Sending_succeeded: '发送成功',
  old_password_no: '旧密码不允许为空',
  New_password_no: '新密码不能为空，由6~16位数字和英文组成!',
  Confirm_new_password: '确认新密码不能为空，由6~16位数字和英文组成!',
  re_enter: '2次输入不一致，请重新输入',
  no_identical: '新密码和原密码不能相同',
  up_password_success: '密码修改成功',
  Old_password_error: '旧密码错误',
  modify_successfully: '修改成功',
  up_Phone: '手机号修改成功',
  modify_phone: '修改手机号码',
  dialog_tips: '确定要修改手机号吗？确定后，会先验证旧手机号。验证通过后，再验证新手机号。',
  old_phone_code: '输入旧手机号验证码',
  Modify_contact_name: '修改联系人姓名',
  Modify_agent_name: '修改代理商名称',
  Modify_renewal_fs: '修改续费联系方式',
  Modify_detailed_address: '修改详细地址',
  org_name: '修改单位名称',
  verifying_phone: '正在验证新手机号…',
  verifying_phone_tow: '正在验证旧手机号…',
  code_success: '验证码发送成功',
  import_phone: '输入新手机号验证码',
  Sending_verification_code: '正在发送验证码…',
  old_password_yes: '旧手机号验证通过',
  New_mobile_number: '新手机号',
  Entera_new_phone: '输入新手机号',
  Renewal_contact_information: '续费联系方式',
  Account_security: ' 为了保障您账号安全，请先完善个人信息',
  take_back: '收回',
  Reset_succeeded: '重置成功',
  row_passwords: '两次输入的密码不一致',
  user_password_no: '用户名或密码不能为空',
  //共用
  Loggingin: '登录中...',
  country: '请选择地区',
  country1: '选择地区',
  loading: '加载中...',
  create_successfully: '创建成功！',
  Pleaseselectanagentfirst: '请先选择代理商',
  Theminimumsalesquantitysonepiece: '销售数量最小为一张',
  Pleaseselectservicecardtype: '请选择服务卡类型',
  Insufficientvoicecardbalance: '语音卡余额不足',
  Recordingcardbalanceisinsufficient: '录音卡余额不足',
  Insufficientbalanceoflocationcard: '定位卡余额不足',
  InsufficientSOScardbalance: 'SOS卡余额不足',
  Fencecardbalanceisinsufficient: '围栏卡余额不足',
  Insufficientvideocardbalance: '视频卡余额不足',
  Theduplexcardbalanceisinsufficient: '双工卡余额不足',
  Insufficientbalanceonvipcard: 'Vip卡余额不足',
  Confirmsalesinformation: '确认销售信息',
  servicecardpasswordmistake: '输入的服务卡密码格式错误',
  Servicecardpasswordinputerror: '服务卡密码输入错误',
  successfulsales: '销售成功',
  Pleaseselecttheunitfirst: '请先选择单位',
  Yourinputisemptypleasereenter: '您的输入为空,请重新输入！',
  Theenteredimeinumberisempty: '您输入的IMEI号码有误，请重新输入！',
  Donotaddrepeatedly: '请勿重复添加！',
  TheQRcodeiswrong: '二维码有误',
  TheIMEInumberiswrong: '您扫入的IMEI号码有误，请重新扫码！',
  Donotscanthecoderepeatedly: '请勿重复扫码',
  Pleaseselectausertype: '请选择用户类型！',
  Pleaseselectaunit: '请选择单位',
  Userprefixnicknamecannotbeempty: '用户前缀昵称不能为空！',
  nicknameNoXhx: '用户前缀呢称由2-26位字符组成',
  PleaseaddIMEInumber: '请添加IMEI号码！',
  YoucanadduptoIMEIsbyscanningthecode: '扫码最多可以添加100个IMEI！',
  YouhaverepeatedlyaddedIMEIpleasedeleteit: '您有重复添加的IMEI，请删除！',
  Yourvoicecardisinsufficient: '您的语音卡不足，请先充值！',
  Yourrecordingcardisinsufficient: '您的录音卡不足，请先充值！',
  Yourlocationcardisinsufficient: '您的定位卡不足，请先充值！',
  YourSOScardisinsufficient: '您的SOS卡不足，请先充值！',
  Yourfencecardisinsufficient: '您的围栏卡不足，请先充值！',
  Yourvideocardisinsufficient: '您的视频卡不足，请先充值！',
  Yourduplexcardisnotenough: '您的双工卡不足，请先充值！',
  Theservicecardpasswordenteredisinthewrongformat: '输入的服务卡密码格式错误',
  Pleaseselectaregion: '请选择区域',
  Changeemailaddress: '修改邮箱地址',
  Editdetailedaddress: '编辑详细地址',
  Bindingplatformisenabled: '已开启绑定平台',
  Bindingplatformhasbeenclosed: '已关闭绑定平台',
  Memberdisplayturnedon: '已开启成员显示',
  Memberdisplayturnedoff: '已关闭成员显示',
  Noisecancellationturnedon: '已开启降噪功能',
  Noisecancellationturnedoff: '已关闭降噪功能',
  deleteOrg: '确认删除该单位信息吗？',
  successfullydeleted: '删除成功',
  successfullyset: '设置成功',
  Thisgroupisalreadythedefaultgroup: '该群组已经是默认群组！',
  deletedUserGroup: '确认移除用户所属群组吗？',
  deletedGroup: '确认删除该群组吗？',
  Youhavenotmodifiedthenoteinformation: '您未修改备注信息',
  Areyousureyouwanttoremovethismember: '确认移除该成员吗？',
  Pleaseselectamembertoadd: '请选择要添加的成员',
  Memberaddedsuccessfully: '成员添加成功',
  Theservicecardpasswordentered: '输入的服务卡密码格式错误',
  Thepasswordsenteredtwiceareinconsistent: '两次输入的密码不一致，请重新输入',
  successfullyopened: '开通成功!',
  Modifycontactnumber: '修改联系电话',
  Changeemailaddress: '修改邮箱地址',
  Modifymailingaddress: '修改通讯地址',
  changeusername: '修改昵称',
  Outofwarrantyandcannotbereplaced: '已过保修期，无法更换',
  Recycledsuccessfully: '回收成功',
  restarttheterminaltotakeeffect: '修改成功,重启终端生效！',
  UserTalkbackSuspended: '已暂停用户对讲功能',
  Theuserintercomfunctionisturnedon: '已开启用户对讲功能',
  shakeoff: '摇开',
  Shaketodeath: '摇毙',
  Unitdispatcherison: '单位调度员已开启',
  Unitdispatcherisclosed: '单位调度员已关闭',
  Changeuseraffiliation: "确定要改变用户所属单位吗?",
  Pleaseselectauser: '请选择用户',
  PleaseentertheoldIMEIcorrectly: '请正确输入15位旧IMEI',
  PleaseenterthenewIMEIcorrectly: '请正确输入15位新IMEI',
  Replacedthecardsuccessfully: '换卡成功',
  TheoriginalIMEIentereddoesnotexist: '输入的原IMEI不存在',
  TheenterednewIMEIisalreadyinuse: '输入的新IMEI已经被使用',
  Cardreplacementfailed: '换卡失败',
  Theverificationcodehasexpiredpleasegetitagain: '验证码已失效，请重新获取！',
  Pleaseentercorrectverifycode: '请输入正确的验证码！',
  Verificationcodeerror: '验证码错误！',
  Pleaseenteramobilephonenumberinthecorrectformat: '请输入正确格式的手机号码',
  Pleaseselectthelisteninggrouptobeadded: '请选择需要添加的监听群组',
  Confirmtoaddlisteninggroup: '确认添加监听群组？',
  Addedsuccessfully: '添加成功',
  adding: '添加中...',
  deleting: '删除中...',
  Areyousuretodeletethislisteninggroup: '确认删除该监听群组吗?',
  GPSison: 'GPS已开启，重启终端生效！',
  GPSisoff: 'GPS已关闭，重启终端生效！',
  Doyouwanttocontinue: '勾选用户中存在定位卡未过期的用户，是否继续？',
  Renewalsuccessful: '续费成功！',
  IMEIdoesnotexist: 'IMEI不存在',
  Insufficientservicecardbalance: '服务卡余额不足',
  andtheterminalneedstoberestarted: '修改所属单位成功，需要重启终端',
  Modifytheaffiliatedunitsuccessfully: '修改所属单位成功',
  rOrg_tips: '单位名称应为4-20位中文、数字、字母、下划线，不能以下划线开头',
  rNamep_tips: '应为 2-10位中文、数字、字母、下划线，不能以下划线开头',
  rNamep_tips20: '应为 2-20位中文、数字、字母、下划线，不能以下划线开头',
  rPhone_tips: '手机号码格式不正确',
  rAgent_tips: '代理商名称应为 4-20位中文、数字、字母、下划线，不能以下划线开头',
  wAgent_tips: '名称由1-15位中文，数字，字母，下划线组成，且不能以下划线开头',
  rGroup_tips: '群组名称应为 2-15个字符',
  rGroup2_tips: '群组名称由2-12位数字，中文，英文组成',
  rAccount_tips: '账号应为6-20位英文、数字和下划线组成',
  rPwd_tips: '密码应为6-16位字母、数字组成',
  rName_tips: '应为 2-7位中文、数字、字母、下划线，不能以下划线开头',
  rNamep1_tips: '用户昵称由2-30个字符组成',
  rEmail_tips: '请输入正确格式的邮箱地址',
  rInt_tips: '请输入正整数',
  rInputNum_tips: '请输入数字',
  rBroad_tips: '输入内容应为中文、数字、字母',
  rVerifyCode_tips: '手机验证码为4位数字',
  rICCID_tips: 'ICCID应为19或20位字母或数字组成',
  rIMEI_tips: 'IMEI应为15位数字组成',
  removegroupleader: '确认移除群主自动删除此自建群组吗？',
  removeselfcreatedgroups: '确认移除自建群组并自动删除吗？',
  removeselfcreatedgroupsTow: '确定要改变用户所属单位并自动删除用户自建群组吗？',
  PleaseselectSOS: '请选择未开启SOS服务的用户',
  Logintimedout: '登录超时！',
  Serverconnectionexception: '服务器连接异常',
  ServerconnectionexceptionLoaing: '加载中',
  Nolocationtrack: '没有位置轨迹',
  Areyousuretodeletethemember: '确认删除该成员吗',
  update_successfully: '更新成功',
  updatecompleted: '更新成功',
  Pleaseselecttheexportdaterange: '请选择导出日期区间，最近90天',
  Thestarttimecannotbegreaterthantheendtime: '开始时间不能大于、等于结束时间',
  Theendtimecannotbelessthanthestarttime: '结束时间不能小于、等于开始时间',
  Areyousureyouwanttodeletethisfence: '确认删除该围栏吗？',
  Thefencenameisduplicated: '围栏名称重复，请修改后重试',
  setptttips: '请选择服务期限',
  Pleaseselectareareplacement: '请选择区域更换',
  Successfuloperation: '操作成功',
  Areyousuretoresettheuserpassword: '确定恢复该用户密码吗？',
  selectedvipcardTpis: '选中的Vip卡用户充值录音、定位、SOS、围栏服务卡会自动过滤',
  selectedpttgpscardTpis: '选中的语音+定位用户充值定位服务卡会自动过滤',
  closeAgentTips: '关闭后下级代理商用户不会显示该服务相关信息，服务期内的用户可继续使用服务，确定关闭吗？',
  vipCardNoTips: 'VIP卡用户的录音、定位、SOS、电子围栏功能都为永久，不需要激活',
  pttCardNoTips: '暂无服务卡需要激活',
  pointtips1: '已开启用户单呼功能',
  pointtips2: '已关闭用户单呼功能',
  LimitspecifiedEnglish: 'select、update、and、or、delete、insert、trancate、char、chr、into、substr、ascii、declare、exec、count、master、drop、execute、script、iframe字段',
  Thecommentcontentcannotcontain: '备注内容不能包含',
  Theagentsremarkscannotcontain: "代理商备注内容不能包含",
  theagencynamecannotcontain: '代理商名称不能包含',
  Thecompanynamecannotcontain: '单位名称不能包含',
  Thegroupnamecannotcontain: '群组名称不能包含',
  Usernamecannotcontain: '用户名称不能包含',
  Registeredsuccessfully:'注册成功',
  UnbindingUserTips:'解绑后用户会清除所有单位群组数据，终端无法登录，是否确定解绑?',
  Failedtocreategrouppleasebinddevicefirst:' 创建群组失败，请先绑定设备',
  Devicebindingsuccessful:'设备绑定成功',
  Devicebindingfaileddifferentownership:'设备绑定失败，不同归属',
  Devicebindingfailedaccountdoesnotexist:'设备绑定失败，账号不存在',
  Devicebindingfailedalreadybound:'设备绑定失败，已绑定',
  Devicebindingfailedalreadyexists:'设备绑定失败，已存在',
  The_maximum_duration_can_only_be_set_to_60_minutes:'最大只能设置60分钟',
  SOS_transmission_interval:'SOS发送间隔',
  Please_set_the_SOS_interval:'请设置SOS间隔时间',
  recyclingServiceCardTips:'确定回收后，该用户会被删除，消耗的服务卡会被回收',
  Pleasebindthedevicefirst:'请先绑定设备'
}
